<template>
  <DashboardTemplate class="course-detail">
    <div v-loading="loading">
      <el-row>
        <el-col :span="24" :sm="12" :md="8">
          <VideoPlay :id="courseId" :video="courseVideo" :image="courseImage" />
        </el-col>
        <el-col :span="24" :sm="12" :md="16" class="text-left ">
          <div class="pd-l-3">
            <CourseHeader
              :id="courseId"
              :title="courseName"
              :time="totaltimeCourse"
              :status="courseStatus"
              :fileList="courseStudyDocumentsFiles"
              :open="openCourse"
              :subjects="courseSubjects"
              @fetchCourseStatus="fetchCourseStatus"
            />
          </div>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" class="text-font-16 mg-t-3">
        <el-tab-pane label="คำอธิบายหลักสูตร" name="description">
          <CourseDescription
            :description="courseDescription"
            :fileList="courseDescriptionFiles"
          />
        </el-tab-pane>
        <el-tab-pane
          v-if="courseSubjects.length > 0"
          label="แผนการเรียนการสอน"
          name="lessonPlan"
          ><CourseLessonPlan :courseId="courseId" :subjectsList="courseSubjects"
        /></el-tab-pane>
      </el-tabs>


    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import CourseHeader from "@/components/course/CourseHeader";
import CourseDescription from "@/components/course/CourseDescription";
import CourseLessonPlan from "@/components/course/CourseLessonPlan";
import VideoPlay from "@/components/social/VideoPlay";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    CourseHeader,
    CourseDescription,
    CourseLessonPlan,
    VideoPlay,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    totaltimeCourse() {
      let time = 0
      this.courseSubjects.map((item) => {
        
        let hours =
          item.totalStudyTime && item.totalStudyTime.hours
            ? item.totalStudyTime.hours
            : 0;
        let minute =
          item.totalStudyTime && item.totalStudyTime.minute
            ? item.totalStudyTime.minute
            : 0;

        time = time + (hours*60) + minute
      });

      return `${parseInt(time/60)}.${time - (parseInt(time/60) * 60) }`;
    },
  },
  data() {
    return {
      activeName: "description",
      courseId: "",
      courseName: "",
      coursetotalStudyTime: null,
      courseImage: "",
      courseVideo: "",
      courseDescription: "",
      courseSubjects: [],
      loading: true,
      courseStatus: 0,
      courseStudyDocumentsFiles: [],
      courseDescriptionFiles: [],
      openCourse: "",
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchDetailCourse();
    if (this.user){
      this.fetchCourseStatus();
    }
    
  },
  methods: {
    setParams() {
      if (this.routeParams != null) {
        if (typeof this.routeParams.courseId != "undefined") {
          this.courseId = this.routeParams.courseId;
        }
      }
    },
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
    },
    fetchDetailCourse() {
      let obj = {
        _id: this.courseId,
      };

      HTTP.post(`detail/course`, obj)
        .then((res) => {

          if (res.data.success) {
            this.courseName = res.data.obj.name;
            this.coursetotalStudyTime = res.data.obj.totalStudyTime;
            this.courseImage = res.data.obj.illustration
              ? res.data.obj.illustration.file
              : "";
            this.courseVideo = res.data.obj.introduction
              ? res.data.obj.introduction.file
              : "";
            this.courseDescription = res.data.obj.courseDescription;
            this.courseSubjects = res.data.obj.subjects.sort((a,b)=>{
              if(a.index > b.index) return 1
              if(a.index < b.index) return -1
              return 0;
            });;
            this.courseStudyDocumentsFiles = res.data.obj.studyDocument;
            this.courseDescriptionFiles = res.data.obj.attachDescription;
            this.openCourse = res.data.obj.durationTime.open;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchDetailCourse error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    fetchCourseStatus() {
      let obj = {
        _id: this.user.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`status/course`, obj).then((res) => {
        
        if (res.data.success) {
          let pending = res.data.obj.pending.filter(
            (filter) => filter.courseId == this.courseId
          );

          let approved = res.data.obj.approved.filter(
            (filter) => filter.courseId == this.courseId
          );

          let disapproval = res.data.obj.disapproval.filter(
            (filter) => filter.courseId == this.courseId
          );

          if (pending.length > 0) {
            this.courseStatus = 2;
          }

          if (approved.length > 0) {
            this.courseStatus = 1;
            
          }

          if (disapproval.length > 0) {
            this.courseStatus = 3;
          }
        }
      });
    },
  },
};
</script>
